<template>
    <dialog-template 
        :append-to-body="true"
        :visible="dialogVisible" 
        @update:visible="cancel"
        :width="'400px'">
        <div class="fx-v-center" slot="title">
            <h1 class="fs-16 fw-600 color-333">{{ ['新建商品分组', '编辑商品分组', '删除分组'][['create', 'update', 'delete'].indexOf(mode)] }}</h1>
            <button v-if="mode === 'update' && !groupInfo.is_default" @click="mode = 'delete'" class="text-btn danger">删除分组</button>
        </div>
        <div class="form pl-11" v-if="mode !== 'delete'">
            <div class="item">
                <span class="title required">分组名称：</span>
                <div class="value">
                    <div class="input-wrapper">
                        <input placeholder="请输入分组名称" class="primary" ref="nameInput" :maxlength="groupLimitNum" v-model="name" type="text" autofocus @input="inputSpaceLimit($data, 'name')"/>
                        <span class="suffix">{{name.length}}/{{groupLimitNum}}</span>
                    </div>
                </div>
            </div>
            <div class="item">
                <span class="title">分组说明：</span>
                <div class="value">
                    <div class="input-wrapper">
                        <textarea placeholder="请输入分组说明" maxlength="50" v-model="remarks" class="primary" type="text" @input="inputSpaceLimit($data, 'remarks')"/>
                        <span class="suffix" style="bottom: 10px; top: auto;">{{remarks.length}}/50</span>
                    </div>
                    
                </div>
            </div>
        </div>
        <div v-else>
            <p style="font-size: 14px;color: #333333;font-weight: 500; text-align:center">确定要删除分组 <span class="color-green">{{ name }}</span> 吗？</p>
            <p style="font-size: 12px;color: #E51C23; margin-top: 8px; text-align:center" v-if="groupInfo.goods_num > 0">分组内含商品{{ groupInfo.goods_num }}种，删除分组将同步删除分组内商品</p>
        </div>
        <div class="btn-wrapper" slot="footer">
            <el-button size="medium" type="primary" @click="onSubmit" :disabled="name === ''" v-if="mode !== 'delete'">确认</el-button>
            <el-button type="danger" v-else @click="onSubmit">确认删除</el-button>
            <el-button size="medium" plain @click="cancel">取消</el-button>
        </div>
    </dialog-template>
</template>

<script lang="tsx">
import { createComponent, ref, createElement, computed } from '@vue/composition-api'
import { $fetch } from '@/api/index'
import { openMessage, openWarning } from '@/utils/system.tsx'
import { debounceSubmit } from '@/utils/index'
import { CreateElement } from 'vue/types/vue'
import { inputSpaceLimit } from '@/utils'

export default createComponent<{
    group: any,
    allGroup: any[]
    groupId: number
    secondGroupId: number
    level: number
}>({
    props: {
        group: {},
        allGroup: {},
        level: Number,
        groupId: Number,
        secondGroupId: Number
    },

    setup: (props, ctx) => {
        
        const dialogVisible = ref(false)
        const isLoading = ref(false)
        const groupInfo = ref({})
        const mode = ref('create')
        const remarks = ref('')
        const name = ref('')
        let onSuccess: (type: string) => void = () => {}
        let initMode = ''

        const groupLimitNum = computed(() => {
            console.log('=====,', props)
            if (props.group.id === 0) {
                return 10
            }
            if (mode.value === 'update' && props.level === 1) {
                return 10
            }
            return 5
        })

        const onSubmit = computed(() => debounceSubmit(submit) )

        function open(options: {
            mode: 'create' | 'update' | 'delete',
            callback: (type: string) => void
        }) {
            dialogVisible.value = true
            initMode = options.mode
            mode.value = options.mode
            onSuccess = options.callback
            ctx.root.$nextTick(() => {
                (ctx.refs.nameInput as any).focus()
            })
            if (options.mode === 'update') {
                getGroupInfo()
            } else if (options.mode === 'create') {
                remarks.value = ''
                name.value = ''
            }
        }

        function resetModle() {
            name.value = ''
            remarks.value = ''
        }

        function getGroupInfo() {
             console.log(props, '------')
            console.log(props.group, '----props.group.secondary_group.id')
            let params = {}
            if (+props.level === 2) {
                params = {
                    group_id: props.groupId,
                    secondary_group_id: props.secondGroupId
                }
            } else if (+props.level === 1) {
                params = {
                    group_id: props.groupId,
                }
            }
            $fetch.post({
                url: '/goods/getgroupinfo',
                params
            }).then(data => {
                name.value = data.name
                remarks.value = data.intro
                groupInfo.value = data
            }).catch(e => {
                openMessage('error', e.message)
            })
        }

        function submit() {
            if (mode.value === 'create') {
                return createGroup()
            } else if (mode.value === 'update') {
                return updateGroup()
            } else if (mode.value === 'delete') {
                return deleteGroup()
            }
        }

        function createGroup() {
            if (isLoading.value) { return }
            if (!name.value) {
                return openMessage('info', '分组名不能为空')
            }

            let path = ''
            const params: {
                group_id?: number
            } = {}
            if (+props.level === 1 && props.group.id !== 0) {
                path = '/goods/addsecondarygroup'
                params.group_id = props.group.id
            } else if (+props.level === 1) {
                path = '/goods/addgroup'
            }
            isLoading.value = true
            return $fetch.post({
                url: path,
                params: {
                    ...params,
                    name: name.value,
                    intro: remarks.value
                }
            }).then(() => {
                dialogVisible.value = false
                openMessage('success', '新增成功')
                onSuccess('add')
            }).catch(e => {
                openMessage('error', e.message)
            }).finally(() => {
                isLoading.value = false
            })
        }

        function updateGroup() {
            if (isLoading.value) { return }
            if (!name.value) {
                return openMessage('info', '分组名不能为空')
            }
            let path = ''
            const params: {
                group_id?: number,
                secondary_group_id?: number
            } = {}
            if (+props.level === 2) {
                path = '/goods/editsecondarygroup'
                params.group_id = props.groupId
                params.secondary_group_id = props.secondGroupId
            } else if (+props.level === 1) {
                path = '/goods/editgroup'
                params.group_id = props.groupId
            }
            isLoading.value = true
            return $fetch.post({
                url: path,
                params: {
                    ...params,
                    name: name.value,
                    intro: remarks.value
                }
            }).then(() => {
                dialogVisible.value = false
                openMessage('success', '修改成功')
                onSuccess('edit')
            }).catch(e => {
                openMessage('error', e.message)
            }).finally(() => {
                isLoading.value = false
            })
        }

        function deleteGroup() {
            let params = {}

            if (+props.level === 1) {
                params = {
                    group_id: props.groupId
                }
            } else if (+props.level === 2) {
                params = {
                    group_id: props.groupId,
                    secondary_group_id: props.secondGroupId
                }
            }

            return $fetch.post({
                url: '/goods/deletegroup',
                params
            }).then(() => {
                onSuccess('delete')
                dialogVisible.value = false
                openMessage('success', '删除成功')
            }).catch(e => {
                openMessage('error', e.message)
            })
        }

        function cancel() {
            if (mode.value !== 'delete') {
                dialogVisible.value = false
            } else {
                mode.value = initMode
            }
        }

        return {
            groupInfo,
            open,
            mode,
            dialogVisible,
            name,
            remarks,
            submit,
            deleteGroup,
            cancel,
            groupLimitNum,
            onSubmit,
            inputSpaceLimit
        }
    }
})
</script>

<style lang="scss" scoped>
.form {
    .item {
        display: flex;
        // align-items: center;

        & + .item {
            margin-top: 12px;
        }

        .title {
            padding-top: 10px;
            line-height: 20px;
            font-size: 14px;
            color: #333333;
        }

        .value {
            flex: 1;
            overflow: hidden;

            .input-wrapper {
                position: relative;
                width: 100%;
            }

            textarea {
                height: 80px;
            }

            .suffix {
                position: absolute;
                right: 8px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 14px;
                color: #999999;
            }
        }
    }
}

.btn-wrapper {
    text-align: center;
}
</style>
